<template>
    <div class="survey-checkbox-container">
        <md-checkbox v-model="model" value="1"
                     class="md-primary" v-on:change="onModelChange">{{field.name}}</md-checkbox>
        <div class="checkbox-children-container" v-if="model && model !== 0 && model !== '0'">
            <div class="checkbox-children-container__child"
            v-for="(child, index) in field.children" v-bind:key="index">
                <survey-field v-bind:field="child"></survey-field>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-param-reassign */

export default {
  name: 'SurveyCheckbox',
  data() {
    return {
      model: this.field.value,
    };
  },
  props: ['field'],
  methods: {
    onModelChange() {
      if (!this.model) {
        this.model = '0';
        this.clearChildren(this.field);
      }

      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
    clearChildren(node) {
      node.children.forEach((child) => {
        child.value = undefined;
      });
    },
  },
};
</script>

<style src="./SurveyCheckbox.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyCheckbox/SurveyCheckbox.vue